<template>
  <v-container>
    <v-card class="rounded-t-lg">
      <v-card-title class="title style-color-main-gray">
        <span>Логирование</span>
        <v-text-field
          v-model="search.value"
          append-icon="search"
          label="Поиск"
          placeholder="Для поиска нажмите Enter или кнопку поиск"
          dense
          outlined
          class="py-3 my-3"
          @change="searchData"
          @click:append="searchData"
          clearable
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn
            depressed
            color="transparent"
            width="100%"
            @click="reloadData"
          >
          Обновить
        </v-btn>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="getItems"
          :loading="isLoading"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.size"
          :options.sync="options"
          :server-items-length="getCount"
          :footer-props="{'items-per-page-options':[25,50,100]}"
          class="elevation-2 rounded-b-lg rounded-t-0"
      >
        <template v-slot:item.dtime_send ="{item}">
          {{ displayDate(item.dtime_send ,true) }}
        </template>
        <template v-slot:item.visitor ="{item}">
          {{ item.visitor.send}}<br> <span v-if="item.visitor.user">{{ item.visitor.user}}</span>
        </template>
        <template v-slot:item.dtime_result ="{item}">
          {{ displayDate(item.dtime_result ,true) }}
        </template>
        <template v-slot:item.is_success ="{item}">
          <v-icon v-if="item.is_success">
          done
        </v-icon>
        <v-icon v-else>
          close
        </v-icon>
        </template>
        <template v-slot:item.actions ="{item}">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  @click="openDialog(item, 'resend')"
                  medium
                  v-on="on"
              >
                repeat
              </v-icon>
            </template>
            <span>Переотправить</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-card-text>Данные отсутствуют</v-card-text>
        </template>
      </v-data-table>
    </v-card>
    <ReSendDialog
        v-if="dialog.resend"
        :opened="dialog.resend"
        :item="selected"
        @close="closeDialog"
    ></ReSendDialog>
  </v-container>
</template>


<script>

import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import ReSendDialog from "@/modules/recording/page/admin/emails/ReSendDialog.vue";
import names from "@/modules/recording/routers/names";
import {mapActions, mapGetters} from "vuex";
import {displayDate} from "@/helper";

export default {
  name: "List",
  mixins: [
    PaginatedDataMapperMixin,
  ],

  components: {
    ReSendDialog
  },
  computed: {
    ...mapGetters({
      getItems: 'emails/getEmails',
      getCount: 'emails/getEmailsCount',
      isLoading: 'emails/isLoadingEmails',
    }),
  },
  data() {
    return {
      dialog: {
        resend: false
      },
      selected: undefined,
      headers: [
        {text: 'Мероприятие', sortable: false, align: 'left', value: "event",},
        {text: 'Посетитель', sortable: false, align: 'left', value: "visitor",},
        {text: 'Расширенная информация', sortable: false, align: 'left', value: "extra_data.trigger_event",},
        {text: 'Дата начала отправки', sortable: false, align: 'left', value: "dtime_send",},
        {text: 'Дата завершения', sortable: false, align: 'left', value: "dtime_result",},
        {text: 'Статус', sortable: false, align: 'left', value: "is_success",},
        {text: 'Действия', sortable: false, align: 'left', value: "actions",},
      ],
      search: {
        parameter: 'search',
      },
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    displayDate,
    ...mapActions({
      loadList: 'emails/loadEmailsList',
    }),
    goDetail(item){
      this.$router.push({
        name: names.ADMINEVENTS.DETAIL,
        params: { event: item.id },
      })
    },
    loadData(url = undefined) {
      this.loadList({
        url: url,
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url)
        }
      })
    },
    openDialog(item, dialog) {
      for (const key of Object.keys(this.dialog)){
          this.dialog[key] = false
      }
      this.dialog[dialog] = true
      this.selected = item
    },
    closeDialog() {
      this.reloadData()
      for (const key of Object.keys(this.dialog)){
        this.dialog[key] = false
      }
    },
  }
}
</script>

<style scoped>
  .row-pointer >>> tbody tr :hover {
    cursor: pointer;
  }
</style>
